/* Deserializers */
import filterDeserializers from '../../deserializers/filterDeserializers';
import bannerDeserializers from '../../deserializers/bannerDeserializers';
import featureToggleDeserializers from '../../deserializers/featureToggleDeserializers';
import experimentDeserializers from '../../deserializers/experimentDeserializers';
import voltranDeserializers from '../../deserializers/voltranDeserializers';
import cmsComponentDeserializers from '../../deserializers/cmsComponentDeserializers';
import cartDeserializers from '../../deserializers/cartDeserializers';

function serializeStateSlice(rawStateSlice, serializers) {
  let result = {};

  Object.entries(rawStateSlice).forEach(([key, value]) => {
    if (serializers[key]) {
      result[key] = serializers[key](value);
    } else {
      result[key] = value;
    }
  })

  return result;
}

const reduxJsonManager = {
  setSerializers(serializersDict = {}) {
    this.serializersDict = serializersDict;
  },

  fromJSON(jsonString) {
    const lowLevelData = JSON.parse(jsonString);
    const result = {};

    for (const stateName in lowLevelData) {
      if (Object.prototype.hasOwnProperty.call(lowLevelData, stateName)) {
        const stateSlice = lowLevelData[stateName];
        if (this.serializersDict[stateName]) {
          result[stateName] = serializeStateSlice(
            stateSlice,
            this.serializersDict[stateName]
          );
        } else {
          result[stateName] = stateSlice;
        }
      }
    }

    return result;
  },

  toJSON(data) {
    return JSON.stringify(data);
  },
};

reduxJsonManager.setSerializers({
  filterState: filterDeserializers,
  bannerState: bannerDeserializers,
  featureToggleState: featureToggleDeserializers,
  experimentState: experimentDeserializers,
  voltranState: voltranDeserializers,
  cmsComponentState: cmsComponentDeserializers,
  cartState: cartDeserializers,
});

export default reduxJsonManager;
